export const encoder = new TextEncoder();
export const decoder = new TextDecoder();
//# sourceMappingURL=encoder.js.map